import axios from 'axios'

const token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.log('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

export const axiosInstance = () => {
    return axios.create({
        baseURL: '',
        timeout: 60000,
        responseType: 'json',
        headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
}

export const uploadFile = async file => {
    const resp = {
        error: null,
        data: null,
    }
    const formData = new FormData()
    formData.append('file', file)
    await axiosInstance()
        .post('/conversion/text', formData)
        .then(data => {
            resp.data = data
        })
        .catch(e => {
            resp.error = e
        })
    return resp
}

export const getJDMatches = async (text, weightTitle = false) => {
    const remoteOnlyMeta = document.querySelector('meta[name="jobType"]')
    const remote = !!(remoteOnlyMeta && remoteOnlyMeta.content === 'remote')
    const endpoint = weightTitle
        ? '/search/genericJobSuggestions'
        : '/search/genericJobDescriptions'
    const resp = {
        error: null,
        data: null,
    }
    const formData = new FormData()
    formData.append('resume', text)
    if (remote) {
        formData.append('remoteOnly', 1)
    }
    await axiosInstance()
        .post(endpoint, formData)
        .then(data => {
            resp.data = data
        })
        .catch(e => {
            resp.error = e.response && e.response.data.message
        })
    return resp
}

export const scan = async (cv, jd) => {
    try {
        const resumeId = await createResume(cv)
        const jobDescriptionId = await createJobDescription(jd)
        const oppId = await createOpportunity(jobDescriptionId, resumeId)
        return { id: oppId }
    } catch (e) {
        return { error: e.message }
    }
}

const createOpportunity = async (jobDescriptionId, resumeId) => {
    const resp = {
        error: null,
        data: null,
    }

    const formData = new FormData()
    formData.append('job_description_id', jobDescriptionId)
    formData.append('resume_id', resumeId)

    await axiosInstance()
        .post('/v4/opportunities', formData)
        .then(data => {
            resp.data = data.data
        })
        .catch(e => {
            resp.error = e.response && e.response.data
        })

    if (resp?.error) {
        if (resp?.error?.errors?.duplicate_opportunity?.opportunity?.id) {
            return resp.error.errors.duplicate_opportunity.opportunity.id
        }
        throw new Error('Error creating opportunity')
    }
    return resp.data.data.id
}

const createJobDescription = async jd => {
    const resp = {
        error: null,
        data: null,
    }

    const formData = new FormData()
    formData.append('content', jd)

    await axiosInstance()
        .post('/v4/jobs', formData)
        .then(data => {
            resp.data = data
        })
        .catch(e => {
            resp.error = e.response && e.response.data.message
        })

    if (resp?.error) throw new Error('Error creating resume')
    return resp.data.data.id
}

const createResume = async cv => {
    const resp = {
        error: null,
        data: null,
    }

    const blob = new Blob([cv], { type: 'text/plain' })
    const file = new File([blob], 'pasted_resume.txt')

    const formData = new FormData()
    formData.append('name', `auto:resume`)
    formData.append('original_file', file)

    await axiosInstance()
        .post('/v4/resumes', formData)
        .then(data => {
            resp.data = data
        })
        .catch(e => {
            resp.error = e.response && e.response.data.message
        })

    if (resp?.error) throw new Error('Error creating resume')
    return resp.data.data.id
}
